module.exports = __webpack_public_path__ + "static/media/(V)_MG_5368_-_Pro-Natura_-_Moda_Feminina_-_Acessorios.6347062c.jpg";